import { render, staticRenderFns } from "./WebSiteIntegration.vue?vue&type=template&id=4c652d39&scoped=true"
import script from "./WebSiteIntegration.vue?vue&type=script&lang=js"
export * from "./WebSiteIntegration.vue?vue&type=script&lang=js"
import style0 from "./WebSiteIntegration.vue?vue&type=style&index=0&id=4c652d39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c652d39",
  null
  
)

export default component.exports